export const SESSION_FIELDS_ORDER = {
  starts_at: 1,
  ends_at: 2,
  location: 3,
  format: 4,
  track: 5,
  tags: 6,
  level: 7,
  language: 8,
  client_session_id: 9,
  ceu_credits: 10,
};

export const STATIC_VISIBLE_SESSION_FIELDS = [
  'title',
  'description',
  'location',
  'speakers',
  'starts_at',
  'ends_at',
  'range',
];
